/** Full page navigation (reloads the SPA), e.g. to re-initialize the portal */
export const navigateWithReload = (path: string): void => {
  window.location.assign(path);
};
